import React, { Component } from 'react'
import { Col, Row, Input } from 'reactstrap'
import MassMessageModal from "../../Material/MassMessageModal"
import updateFilters from "../../Functions/updateFilters"
import withApolloClient from '../../withApolloClient'
import AdvancedFiltersControl from '../../Filters/AdvancedFiltersControl'
import AppliedAdvancedFilters from '../../Filters/AppliedAdvancedFilters'

class AvailableCarsHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
        }
    }
    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }
    updateSearchTerm = (searchTerm) => {
        updateFilters({ ...this.props.filterValues, searchTerm }, [], this.props.navigate, this.props.location, this.props.setFilterValues)
    }

    render() {
        // The two tabs list different entities -- Available Cars filters `car`,
        // Scheduled Returns filters `car_return`.
        const entity = this.props.activeTab === "Available Cars" ? "car" : "car_return"
        return (
            <Row className="mb-2">
                {this.state.openModal === "MassMessageModal" &&
                    <MassMessageModal handleClose={() => this.toggleModal("")} open={this.state.openModal === "MassMessageModal"} drivers={this.props.selectedIds} />
                }
                <Col xs={4}>
                    <span className="driver-search-filter">
                        <Input type="text" name="searchTerm" placeholder="Search" onChange={(e) => this.updateSearchTerm(e.target.value)} />
                        <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                    </span>
                </Col>
                <Col xs={8} className="text-right mt-2">
                    {this.props.activeTab === "Scheduled Returns" && this.props.selectedIds.length > 0 && <>
                        <a className="driver-list-button" onClick={() => this.toggleModal("MassMessageModal")}>
                            Message Drivers | <i className="fa fa-commenting-o" aria-hidden="true"></i>
                        </a>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                    </>}
                    <AdvancedFiltersControl
                        entity={entity}
                        compact={false}
                        presets={this.props.presets}
                        setPresets={this.props.setPresets}
                        defaultPresets={this.props.defaultPresets}
                    />
                </Col>
                <Col xs={12} className="mt-2">
                    {this.props.selectedIds && this.props.selectedIds.length > 0 && <span className="search-filter-preview">
                        <span> <i className="fa fa-times-circle" onClick={this.props.resetSelectedIds}></i> &nbsp;&nbsp; Selected Drivers</span>
                        {this.props.selectedIds.length}
                    </span>}
                </Col>
                <Col xs={12} className="mt-2 search-filter-container">
                    <AppliedAdvancedFilters
                        entity={entity}
                        context={null}
                        presets={this.props.presets}
                        onPresetsChange={this.props.setPresets}
                    />
                </Col>
            </Row>
        )
    }
}

export default withApolloClient(AvailableCarsHeader)
